var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('span',[_vm._v("\n\t"+_vm._s(_vm._f("formatRecurrenceRule")(_vm.recurrenceRule,_vm.locale))+"\n")]):_c('span',[_vm._v("\n\t"+_vm._s(_vm.$t('calendar', 'No recurrence'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }